import React, { useState, Suspense, lazy } from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Timer from "../../common/Timer";
import { WebsiteUrl } from '../../common/Constants';
import Helmet from "../../common/Helmet";

const CommonFooter = lazy(() => import('../../common/Footer'));

const lang = "de";
const url = `${WebsiteUrl}/de/`;
const TITLE = "Prozentrechner";
const DESCRIPTION = "Nutzen Sie den Prozentsatz-Rechner, um Prozentsätze, Prozentsatzdifferenzen und Prozentänderungen zu berechnen. Diese Anwendung bietet ein leistungsstarkes und umfassendes Werkzeug zum genauen und einfachen Berechnen und Extrahieren von Prozentsätzen.";
const KEYWORDS = "Prozentberechnung, Berechnungswerkzeuge, Prozentsatzdifferenzberechnung, Prozentänderung, Prozentberechnungswerkzeug";
const OG_URL = `${WebsiteUrl}/de/`;
const descriptionHomePage = 'Prozentrechner: Ein leistungsstarkes und umfassendes Werkzeug zum genauen und einfachen Berechnen und Extrahieren von Prozentsätzen. Dieses Tool ermöglicht es Ihnen, den Prozentsatz eines beliebigen Betrags oder einer Zahl zu berechnen sowie den Unterschied zwischen Prozentsätzen und die Veränderung des Prozentsatzes zu berechnen.';
const Cite = "Zitieren";
const Percentage = () => {
    // State für jeden Rechner
    const [calc1, setCalc1] = useState({ value1: '', value2: '', result: '', explanation: '', error: '', showTimer: false });
    const [calc2, setCalc2] = useState({ value1: '', value2: '', result: '', explanation: '', error: '', showTimer: false });
    const [calc3, setCalc3] = useState({ value1: '', value2: '', result: '', explanation: '', error: '', showTimer: false });
    const [calc4, setCalc4] = useState({ value1: '', value2: '', result: '', explanation: '', error: '', showTimer: false });
    const [calc5, setCalc5] = useState({ value1: '', value2: '', result: '', explanation: '', error: '', showTimer: false });

    const [option, setOption] = useState('increase');

    // Berechnungsfunktion
    const handleCalculate = (calcType, setCalc) => {
        setCalc(prev => ({ ...prev, showTimer: true, error: '', result: '', explanation: '' }));

        const val1 = parseFloat(calcType.value1);
        const val2 = parseFloat(calcType.value2);

        if (isNaN(val1) || isNaN(val2)) {
            setCalc(prev => ({ ...prev, error: 'Bitte geben Sie beide Werte korrekt ein.' }));
            return;
        }

        let calculatedResult = 0;
        let calcExplanation = '';

        switch (calcType.type) {
            case 'percentageOf':
                calculatedResult = (val1 / 100) * val2;
                calcExplanation = `${val1}% von ${val2} = (${val1}/100) * ${val2} = ${calculatedResult.toFixed(2)}`;
                break;
            case 'valueOfPercentage':
                calculatedResult = (val1 / val2) * 100;
                calcExplanation = `${val1} sind wie viele % von ${val2} = (${val1} / ${val2}) * 100 = ${calculatedResult.toFixed(2)}%`;
                break;
            case 'valueOfWhat':
                calculatedResult = (val1 / val2) * 100;
                calcExplanation = `${val1} sind ${calculatedResult.toFixed(2)}% von was ${val2}`;
                break;
            case 'percentageDifference':
                const diff = Math.abs(val1 - val2);
                const sum = val1 + val2;
                calculatedResult = (diff / sum) * 100;
                calcExplanation = `Der Unterschied zwischen ${val1} und ${val2} beträgt ${calculatedResult.toFixed(3)}%`;
                break;
            case 'percentageChange':
                const changeValue = option === 'increase'
                    ? val1 + (val1 * val2) / 100
                    : val1 - (val1 * val2) / 100;
                calculatedResult = changeValue;
                calcExplanation = `${val1} ${option === 'increase' ? 'erhöht' : 'gesenkt'} um ${val2}% = ${calculatedResult.toFixed(2)}`;
                break;
            default:
                setCalc(prev => ({ ...prev, error: 'Ungültiger Berechnungstyp' }));
                return;
        }

        setCalc(prev => ({
            ...prev,
            result: calculatedResult.toFixed(2),
            explanation: calcExplanation
        }));
    };

    const handleOptionChange = (e) => setOption(e.target.value);

    return (
        <Container>
            <Helmet
                TITLE={TITLE}
                WEBSITE_URL={url}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
                LANG={lang}
            />
            <Row style={{ fontSize: '20px', textAlign: 'center' }}>
                {descriptionHomePage}
            </Row>
            <br />
            <Row className='calcualtorStyle'>

                <Row>
                    <div className='p-3 mb-2 mainBackground text-white'>
                        <h1 style={{ fontSize: '18px', textAlign: 'center' }}>Prozentberechnung</h1>
                    </div>
                    <hr />

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {'\u00A0'} <span>was</span> {'\u00A0'}
                        {'\u00A0'} <span>ist</span> {'\u00A0'}
                        <input
                            type="number"
                            value={calc1.value1}
                            onChange={(e) => setCalc1({ ...calc1, value1: e.target.value })}
                            className="form-control ml-2"
                            style={{ height: '60px' }}
                            placeholder='%'

                        />
                        <span>von</span> {'\u00A0'}
                        <input
                            type="number"
                            value={calc1.value2}
                            onChange={(e) => setCalc1({ ...calc1, value2: e.target.value })}
                            className="form-control ml-2"
                            style={{ height: '60px' }}
                        />
                        <button className="btn btn-primary " style={{ backgroundColor: '#43314A', borderColor: '#43314A', }} onClick={() => handleCalculate({ ...calc1, type: 'percentageOf' }, setCalc1)}>
                            {calc1.showTimer ? <Timer duration={3} onTimeout={() => setCalc1(prev => ({ ...prev, showTimer: false }))} /> : "Berechnen"}
                        </button>
                    </div>
                    <div>
                        <br />
                        {calc1.error && <p className='p-3 mb-2 bg-warning text-white'>Fehler: {calc1.error}</p>}
                        {calc1.result && !calc1.showTimer && (
                            <>
                                <p className='p-3 mb-2 mainBackground text-white'>Ergebnis: {calc1.result}</p>
                                {calc1.explanation && <p className='p-3 mb-2 bg-info text-white'>Lösungswege: <br />{calc1.explanation}</p>}
                            </>
                        )}
                    </div>
                </Row>

                <hr />
                <Row>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                            type="number"
                            value={calc2.value1}
                            onChange={(e) => setCalc2({ ...calc2, value1: e.target.value })}
                            className="form-control ml-2"
                            style={{ height: '60px' }}
                        />
                        <span>ist</span>
                        {'\u00A0'}
                        <span>was</span>
                        {'\u00A0'} <span>%</span>
                        {'\u00A0'}
                        <span>von</span>
                        <input
                            type="number"
                            value={calc2.value2}
                            onChange={(e) => setCalc2({ ...calc2, value2: e.target.value })}
                            className="form-control ml-2"
                            style={{ height: '60px' }}
                        />
                        <button className="btn btn-primary " style={{ backgroundColor: '#43314A', borderColor: '#43314A', }} onClick={() => handleCalculate({ ...calc2, type: 'valueOfPercentage' }, setCalc2)}>
                            {calc2.showTimer ? <Timer duration={3} onTimeout={() => setCalc2(prev => ({ ...prev, showTimer: false }))} /> : "Berechnen"}
                        </button>
                    </div>
                    <div>
                        <br />
                        {calc2.error && <p className='p-3 mb-2 bg-warning text-white'>Fehler: {calc2.error}</p>}
                        {calc2.result && !calc2.showTimer && (
                            <>
                                <p className='p-3 mb-2 mainBackground text-white'>Ergebnis: {calc2.result}</p>
                                {calc2.explanation && <p className='p-3 mb-2 bg-info text-white'>Lösungswege: <br />{calc2.explanation}</p>}
                            </>
                        )}
                    </div>
                </Row>

                <hr />
                <Row>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                            type="number"
                            value={calc3.value1}
                            onChange={(e) => setCalc3({ ...calc3, value1: e.target.value })}
                            className="form-control ml-2"
                            style={{ height: '60px' }}
                        />
                      <span>ist</span> 
                        <input
                            type="number"
                            value={calc3.value2}
                            onChange={(e) => setCalc3({ ...calc3, value2: e.target.value })}
                            className="form-control ml-2"
                            style={{ height: '60px' }}
                            placeholder='%'
                        />
                       <span>von</span> {'\u00A0'}
                     <span>was</span> {'\u00A0'}
                        <button className="btn btn-primary " style={{ backgroundColor: '#43314A', borderColor: '#43314A', }} onClick={() => handleCalculate({ ...calc3, type: 'valueOfWhat' }, setCalc3)}>
                            {calc3.showTimer ? <Timer duration={3} onTimeout={() => setCalc3(prev => ({ ...prev, showTimer: false }))} /> : "Berechnen"}
                        </button>
                    </div>
                    <div>
                        <br />
                        {calc3.error && <p className='p-3 mb-2 bg-warning text-white'>Fehler: {calc3.error}</p>}
                        {calc3.result && !calc3.showTimer && (
                            <>
                                <p className='p-3 mb-2 mainBackground text-white'>Ergebnis: {calc3.result}</p>
                                {calc3.explanation && <p className='p-3 mb-2 bg-info text-white'>Lösungswege: <br />{calc3.explanation}</p>}
                            </>
                        )}
                    </div>
                </Row>

                <hr />
                <Row>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                            type="number"
                            value={calc4.value1}
                            onChange={(e) => setCalc4({ ...calc4, value1: e.target.value })}
                            className="form-control ml-2"
                            style={{ height: '60px' }}
                        />
                        <span>verglichen</span> {'\u00A0'}
                    <span>mit</span> {'\u00A0'}
                        <input
                            type="number"
                            value={calc4.value2}
                            onChange={(e) => setCalc4({ ...calc4, value2: e.target.value })}
                            className="form-control ml-2"
                            style={{ height: '60px' }}
                        />
                        <button className="btn btn-primary " style={{ backgroundColor: '#43314A', borderColor: '#43314A', }} onClick={() => handleCalculate({ ...calc4, type: 'percentageDifference' }, setCalc4)}>
                            {calc4.showTimer ? <Timer duration={3} onTimeout={() => setCalc4(prev => ({ ...prev, showTimer: false }))} /> : "Berechnen"}
                        </button>
                    </div>
                    <div>
                        <br />
                        {calc4.error && <p className='p-3 mb-2 bg-warning text-white'>Fehler: {calc4.error}</p>}
                        {calc4.result && !calc4.showTimer && (
                            <>
                                <p className='p-3 mb-2 mainBackground text-white'>Ergebnis: {calc4.result}</p>
                                {calc4.explanation && <p className='p-3 mb-2 bg-info text-white'>Lösungswege: <br />{calc4.explanation}</p>}
                            </>
                        )}
                    </div>
                </Row>

                <hr />
                <Row>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                            type="number"
                            value={calc5.value1}
                            onChange={(e) => setCalc5({ ...calc5, value1: e.target.value })}
                            className="form-control ml-2"
                            style={{ height: '60px' }}
                        />


                        <select className="form-control" value={option} onChange={handleOptionChange} style={{ height: '60px' }}>
                            <option value="increase">erhöhen</option>
                            <option value="decrease">senken</option>
                        </select>


                        <input
                        placeholder="%"
                            type="number"
                            value={calc5.value2}
                            onChange={(e) => setCalc5({ ...calc5, value2: e.target.value })}
                            className="form-control ml-2"
                            style={{ height: '60px' }}
                        />
                        <button className="btn btn-primary " style={{ backgroundColor: '#43314A', borderColor: '#43314A', }} onClick={() => handleCalculate({ ...calc5, type: 'percentageChange' }, setCalc5)}>
                            {calc5.showTimer ? <Timer duration={3} onTimeout={() => setCalc5(prev => ({ ...prev, showTimer: false }))} /> : "Berechnen"}
                        </button>
                    </div>
                    <div>
                        <br />
                        {calc5.error && <p className='p-3 mb-2 bg-warning text-white'>Fehler: {calc5.error}</p>}
                        {calc5.result && !calc5.showTimer && (
                            <>
                                <p className='p-3 mb-2 mainBackground text-white'>Ergebnis: {calc5.result}</p>
                                {calc5.explanation && <p className='p-3 mb-2 bg-info text-white'>Lösungswege: <br />{calc5.explanation}</p>}
                            </>
                        )}
                    </div>
                </Row>
                <hr />
                <Suspense fallback={<div>Wird geladen...</div>}>
                    <CommonFooter lang={lang} url={url} textName={Cite} />
                </Suspense>
                <br />
            </Row>
            <hr/>
        </Container>
    );
};

export default Percentage;
